// Globals
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { Pagination } from '@/components';
import { Table } from '@/ui';
import PickupFiltersContainer from '../../containers/PickupFiltersContainer/PickupFiltersContainer';
import { getPickupTableColumns } from './columns';
import { StyledWrapper } from './PickupListStyles';

// Models
import { IPickup } from '@/models/regions.model';

type TPickupList = {
  pickupList: IPickup[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onDelete: (item: IPickup) => void;
  onUpdate: (item: IPickup) => void;
};

const PickupList = ({ pickupList, isLoading, currentPage, total, onPageChange, onDelete, onUpdate }: TPickupList) => {
  const { t } = useTranslation(['regions']);
  const { canManage } = usePermissions();

  return (
    <StyledWrapper>
      <Table
        scroll={{ x: 'max-content' }}
        columns={getPickupTableColumns({ t, onDelete, onUpdate, canManage: canManage(Resource.PICKUP) })}
        dataSource={pickupList}
        rowKey="id"
        loading={isLoading}
        components={{
          header: {
            wrapper: PickupFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} hideOnSinglePage />
    </StyledWrapper>
  );
};

export default PickupList;
